export default __webpack_public_path__ + "static/wide-1cdfcc8b5921b4598edd19807a70e1c7.png";